import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { getTopImage } from '../util/Helper';

class ItemForDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = { }
  }

  render() { 
    //let colorClass = "kwizda-item-color-" + this.props.item.color.replace("#","");
    //console.log("name:" + this.props.item.name);
    
    return ( 
      <div className="kwizda-item kwizda-item-display">
          <div className={"kwizda-item-header "}>
            <div className="kwizda-item-top-container">
              {/*<h4><ItemName name={this.props.item.name} imageheight={26}></ItemName></h4>*/}
              <img alt='cimke' className="kwizda-item-top-container-image" src={"img/kwizda3_cimkek/" + getTopImage(this.props.item.id)}/>
            </div>
          </div>
          <div className="kwizda-item-desc">
            <div className="kwizda-item-problem">{this.props.item.problem_name}</div>
            <div className="kwizda-item-culturesandusage">
              <div className="kwizda-item-label">Kísérlet megvalósítás időzítése:</div>
              <div>{this.props.item.proposed_time}</div>
              <div className="kwizda-item-label">Megvalósítás helye:</div>
              <div>{this.props.item.agent}</div>
              <div className="kwizda-item-label">Helyszínek száma:</div>
              <div>{this.props.item.dose}</div>
              <div className="kwizda-item-label">Dokumentáció módja:</div>
              <div>{this.props.item.type}</div>
            </div>
          </div>
          <div className="kwizda-item-deadline2" style={{marginTop:30, marginBottom:20}}>
            <div>Jelentkezési határidő: {this.props.item.deadline}</div>
          </div>
      </div>
     );
  }
}
 
export default withRouter(ItemForDisplay);
